import { matchPath } from 'react-router';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { safeParseInt } from 'utils/numbers';

export const getCurrentlyViewedProjectId = createSelector(
  [(state: IState) => state.router.location.pathname],
  (pathname): number | undefined => {
    const match = matchPath(`/:account_id/projects/:project_id/*`, pathname);

    // Sometimes a route segment (like 'dashboard') is used instead of 'project_id' in the URL (e.g.: /:account_id/projects/dashboard)
    // In this case, converting 'dashboard' to a number would result in NaN.
    // This NaN value then causes dependent selectors to always recompute!
    // (as NaN is never equal to itself ==> never equal to the cached value)
    return safeParseInt(match?.params.project_id);
  }
);
